import React from 'react';
import moment from 'moment'

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";

// MUI Core
import IconButton from '@material-ui/core/IconButton';

// MUI Icons
import Close from '@material-ui/icons/Close';

const FlightCard = (props) => {
    const returnTimes = (time) => {
        if (time instanceof Date) {
            return time;
        } else if (time) {
            return time.toDate();
        } else {
            return null
        }
    }

    const [departureTime, arrivalTime] = [returnTimes(props.flight.departureTime), returnTimes(props.flight.arrivalTime)];

    return (
        <Card style={{ backgroundColor: props.isSelected ? "#efe6e6" : 'white', boxShadow: "0px 0px 8px 0px #888888", borderRadius: "5px" }}>
            {props.isSelected && (
                <div style={{ position: 'absolute', top: '8px', right: '8px' }}>
                    <IconButton
                        onClick={props.clearFlight}
                    >
                        <Close color='secondary' />
                    </IconButton>
                </div>
            )}
            <GridContainer style={{ textAlign: "center", color: "black !important" }}>
                <GridItem xs={4}>
                    <h4 style={{ textAlign: "center", color: "black !important" }}><b>{props.flight.number}</b></h4>
                </GridItem>
                <GridItem xs={4}>
                    <h6 style={{ marginTop: "10px", color: "black !important" }}>{props.flight.aircraftType}</h6>
                </GridItem>
                <GridItem xs={4}>
                    <h4 style={{ textAlign: "center", color: "black !important" }}><b>{props.flight.airlineName}</b></h4>
                </GridItem>
            </GridContainer>
            <GridContainer style={{ textAlign: "center" }}>
                <GridItem xs={5}>
                    <h2 style={{ margin: "0", color: "black !important" }}><b>{props.flight.originAirport}</b></h2>
                </GridItem>
                <GridItem xs={2}>
                    <h4 style={{ textAlign: "center", color: "black !important" }}><b>=></b></h4>
                </GridItem>
                <GridItem xs={5}>
                    <h2 style={{ margin: "0", color: "black !important" }}><b>{props.flight.destinationAirport}</b></h2>
                </GridItem>
                <GridItem xs={12}>
                    <h5 style={{ textAlign: "center", color: "black !important" }}>Departure: <b>{departureTime ? moment(departureTime).format('YYYY-MM-DD HH:mm') : 'N/a'}</b></h5>
                    <h5 style={{ textAlign: "center", color: "black !important" }}>Arrival: <b>{arrivalTime ? moment(arrivalTime).format('YYYY-MM-DD HH:mm') : 'N/a'}</b></h5>
                    <p>{props.flight.timezone}</p>
                </GridItem>
            </GridContainer>
        </Card>
    )
}

export default FlightCard


// WEBPACK FOOTER //
// ./src/components/Card/FlightCard.jsx